import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  loading: false,
  noData: false,
  users: [],
  newUser: {
    categories: [
      { id: 0, name: 'All' }
    ],
    brands: [
      { id: 0, name: 'All' }
    ]
  },
  editUser: {}
}

const getters = {

}

const actions = {
  getUsers ({ commit }) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getmyUsers'
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_users', response.data.payload)
            commit('SET_loading', false)
            commit('SET_noData', false)
          } else {
            commit('SET_loading', false)
            commit('SET_noData', true)
          }
          resolve()
        })
        .catch(error => {
          commit('SET_loading', false)
          commit('SET_noData', true)
          console.log(error)
        })
    })
  },
  getNewUserCategories ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_userCategories', response.data.payload.category)
            resolve()
          } else if (response.data.error) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getNewUserBrands ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_userBrands', response.data.payload.brand)
            resolve()
          } else if (response.data.error) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getUser ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getmyUser',
        payload: {
          user_id: filter.userId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_user', response.data.payload.data)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  saveUser ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveUser',
        payload: {
          username: filter.username,
          password: filter.password,
          business_title: filter.businessTitle,
          full_name: filter.fullName,
          categories: filter.categories,
          brands: filter.brands,
          user_id: filter.userId
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  deleteUser ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'deleteUser',
        payload: {
          userIds: filter.userIds
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, bool) {
    state.loading = bool
  },
  SET_noData (state, bool) {
    state.noData = bool
  },
  SET_users (state, data) {
    state.users = data
  },
  SET_userCategories (state, data) {
    state.newUser.categories = data
    state.newUser.categories.unshift({ id: 0, name: 'All' })
  },
  SET_userBrands (state, data) {
    state.newUser.brands = data
    state.newUser.brands.unshift({ id: 0, name: 'All' })
  },
  SET_user (state, data) {
    state.editUser = data
  },
  updateBusinessTitle (state, data) {
    state.editUser.business_title = data
  },
  updateFullName (state, data) {
    state.editUser.full_name = data
  },
  updateUsername (state, data) {
    state.editUser.username = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js